/** File types accepted for upload (picker + runtime validation). */
export const ACCEPTED_FILE_EXTS = [
  ".cls",
  ".trigger",
  ".page",
  ".component",
  ".js",
  ".html",
  ".xml",
  ".csv",
  ".json",
  ".txt",
  ".log",
  ".pdf",
  ".xlsx",
  ".xls",
  ".doc",
  ".docx",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".svg",
] as const;

export const ACCEPTED_FILE_ATTR = ACCEPTED_FILE_EXTS.join(",");
export const ACCEPTED_FILE_LABEL = ACCEPTED_FILE_EXTS.join(" ").replace(/\./g, "");

export const QUICK_ACTIONS = [
  {
    label: "Scan my org",
    query: "Analyze my Salesforce org and summarize the key metadata",
  },
  {
    label: "Review triggers",
    query:
      "List all Apex triggers and check for best practice violations",
  },
  {
    label: "Generate test class",
    query:
      "Generate a test class for the most recently modified Apex class",
  },
  {
    label: "Security check",
    query: "Run a security scan on my org's custom Apex code",
  },
  {
    label: "Find unused fields",
    query:
      "Find custom fields that have no data populated across all objects",
  },
] as const;
